/* eslint-disable import/no-cycle */
import Http from '@/api/http';
/* eslint-enable import/no-cycle */

export default class User {
    static getUser() {
        return Http.get('/user');
    }

    static getRoles() {
        return Http.get('/user/roles');
    }
}
